import { useState } from "react";

import { UpdateProgramForm } from "@/components/pages_logged_in/program/components/UpdateProgramForm";
import { Callout } from "@/components/ui/callout";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogInner,
  DialogTitle,
} from "@/components/ui/dialog";
import { MainProgram, MiniProgram } from "@/types/programs";

interface UpdateProgramsDialogProps {
  open: boolean;
  afterUpdateProgram: () => void;
  onClose: () => void;
  program: MainProgram | MiniProgram;
}

export function UpdateProgramsDialog({
  open,
  afterUpdateProgram,
  onClose,
  program,
}: UpdateProgramsDialogProps) {
  const [errorMessage, setErrorMessage] = useState<string>();

  return (
    <Dialog
      open={open}
      onOpenChange={(isOpen) => {
        if (!isOpen) {
          onClose();
        }
        if (isOpen) {
          setErrorMessage(undefined);
        }
      }}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Update Program</DialogTitle>
        </DialogHeader>
        <DialogInner>
          {errorMessage && (
            <div className="mb-2">
              <Callout variant="error" icon={null}>
                {errorMessage}
              </Callout>
            </div>
          )}

          <UpdateProgramForm
            onCompleted={() => {
              afterUpdateProgram();
            }}
            onError={(err) => {
              setErrorMessage(err?.message);
            }}
            program={program}
          />
        </DialogInner>
      </DialogContent>
    </Dialog>
  );
}
